import {
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';

import { Subscription } from 'rxjs';

import {
  AccountWithLocation,
  LocationSwitcherService,
} from './location-switcher.service';
import { SelectedLocation } from './models';
import { AppIcon, AppIconColor, AppIconSize } from '@tablesready/frontend-icons';

@Component({
  selector: 'tablesready-location-switcher',
  templateUrl: './location-switcher.component.html',
  styleUrls: ['./location-switcher.component.scss'],
})
export class LocationSwitcherComponent implements OnInit, OnDestroy {
  @Input() id = 'switcher';
  @Input() width = '160px';
  @Input() popoverSide: 'left' | 'right' = 'left';

  accounts: AccountWithLocation[] = [];
  selectedLocation?: SelectedLocation;
  selectedAccount?: string;
  icon = AppIcon;
  size = AppIconSize;
  iconColor = AppIconColor;

  private readonly subscriptions = new Subscription();

  constructor(private readonly locationSwitcherService: LocationSwitcherService) { }

  ngOnInit(): void {
    this.subscriptions.add(this.locationSwitcherService.initData().subscribe());

    const locationSub = this.locationSwitcherService.selectedLocation$
      .subscribe((loc) => {
        this.selectedLocation = loc;
        if (loc) {
          this.selectedAccount = loc.account;
        }
      });
    this.subscriptions.add(locationSub);

    const accountSub = this.locationSwitcherService.accounts$
      .subscribe((accounts) => {
        this.accounts = accounts;
      });
    this.subscriptions.add(accountSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  selectLocation(locationId: string): void {
    this.locationSwitcherService.selectLocation(locationId);
  }
}
